<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    title="续保成功"
    :footer-hide="true"
    width="630"
    class="my-modal top p-b"
  >
    <div class="follow-up-container">
      <div class="fee-status">
        <Form ref="form" :model="form" :label-width="110" class="modal-form" :rules="ruleInline">
          <FormItem v-if="form.payState == 2" prop="newPolicyNo" label="新保单号">
            <Input v-model="form.newPolicyNo" :disabled='form.renewalSource == 1' placeholder="请输入新保单号"/>
          </FormItem>

          <FormItem key="renewalSource" prop="renewalSource" :rules="$units.formRule.required(`请选择续保方式`)" style="margin-top:15px;">
            <template #label>
              <span>续保方式</span>
              <Poptip trigger="hover" transfer transfer-class-name="my-poptip left3">
                <template #content>
                  <p>原单续保：续保后保单号不变</p>
                  <p>重投：不可续保的产品，重新投保后，生成新保单、且重新计算等待期</p>
                  <p>新单：原保单到期后，续保产生新保单，无等待期</p>
                </template>
                <Icon type="ios-help-circle-outline" />
              </Poptip>
            </template>
            <RadioGroup v-model="form.renewalSource" @on-change='changeRenewal'>
              <Radio style="margin-right:20px;" label="1">原单续保</Radio>
              <Radio style="margin-right:20px;" label="3">重投（非续保）</Radio>
              <Radio style="margin-right:20px;" label="2">新单</Radio>              
              <!-- <Radio style="margin-right:20px;" label="4">转新产品</Radio> -->
            </RadioGroup>
          </FormItem>

          <FormItem prop="serverEndDate" label="实际续保日期" v-if="form.payState == 2" style="margin-top:25px;">
            <DatePicker
              type="date"
              split-panels
              transfer
              v-model="form.serverEndDate"
              placeholder="请选择"
            ></DatePicker>
          </FormItem>
        </Form>
      </div>

      <div class="action-buttom">
        <div class="buttom-box">
          <Button class="cancel" @click="visible=false">取消</Button>
          <Button type="primary" @click="ok">确认</Button>
        </div>        
      </div>
    </div>
  </Modal>
</template>

<script>
import filters from '@/api/filter';
export default {
  props:['getInsureList'],
  data() {
    return {
      commissionDTOList:[],
      visible: false,
      failureType:[],
      form:{
        payState:2,
        serviceStateDetail:'',
        newPolicyNo:'',
        serviceContent:'',
        renewalSource:'',
        serverEndDate:'',
      },
      ruleInline:{
        newPolicyNo:[
          { required: true, message: '请填写新保单号', trigger: 'blur' }
        ],
        serverEndDate:[
          { required: true, type: 'date', message: '请选择时间', trigger: 'change' }
        ]
      },
      id:null,
      policyNo:null
    };
  },

  methods: {
    open(data) {
      this.$refs.form.resetFields();
      this.visible = true;
      this.id = data.id;
      this.policyNo = data.policyNo;
      this.form.renewalSource = '';
    },

    ok() {
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return
        }
        this.submit();
      })      
    },

    changeRenewal(value) {
      if(value == 1){
        this.form.newPolicyNo = this.policyNo;        
      }else if(this.form.newPolicyNo == this.policyNo && value != 1){
        this.form.newPolicyNo = '';
      }
    },

    submit(){
      let data = {
        id:this.id,
        serviceState:2, //流程状态(1、待跟进 2、跟进中 3、跟进完成)
        payState:2, //续保状态 1 待续保  2续保成功  3 续保失败
        newPolicyNo:this.form.newPolicyNo, //新单保单号
        renewalSource:this.form.renewalSource,//续保方式
        serverEndDate:this.form.serverEndDate?filters.filterTime(this.form.serverEndDate, 'YYYY-MM-DD'):'',//实际续保日期
      }
      this.$http({
        url: `/buz/policyShortRenewalRecord/updateRenewalRecord`,
        type: "POST",
        data,
        apiPermissionCode:'renewalManage_01_5'
      }).then((res) => {
        this.$notice.success("操作成功");
        this.getInsureList();
        this.visible = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.follow-up-container {
  padding: 0 0 5px 10px;
  .ivu-icon-ios-help-circle-outline {
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    margin-left: 4px;
  }
  .fee-status {
    .total {
      display: flex;
      border: 1px solid #e8eaec;
      border-top: none;
      border-right: none;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.23%;
        border-right: 1px solid #e8eaec;
      }
    }
    .failure-type{
      display: flex;
      flex-wrap: wrap;
      .failure-btn {
        width: 105px;
        height: 32px;
        border-radius: 4px;
        background: #F5F7F9;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3C464F;
        font-size: 14px;
        margin-bottom: 10px;
        margin-right: 10px;
      }

      .failure-btn:hover {
        cursor: pointer;
      }
      
      & .active {
        background: rgba(235,241,255,0.39);
        color: #236DFF;
        border: 1px solid #236DFF;
      }
    }
  }
}
.action-buttom {
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .buttom-box {
    width: 50%;
    display: flex;
    justify-content: center;
    justify-content: space-between;
    Button {

      width: 140px;
      height: 36px;;
    }
    .cancel {
      width: 120px;
      border-color: #236dff;
      color: #236dff;
    }
  }
  
}
</style>